import useRelatedProductsAnalytics from './useRelatedProductsAnalytics';
import useRelatedProductsData from './useRelatedProductsData';
import useRelatedProductsState from './useRelatedProductsState';
import useRelatedProductsTabs from './useRelatedProductsTabs';

export default function useRelatedProductsTabbedView({
  alternativeProducts,
  brand,
  breakpoint,
  isApparel,
  isRecoBrandProductsFetched,
  isRecoBrandProductsRefetching,
  isRecommendationsProductsFetched,
  isRecommendationsProductsRefetching,
  isRelatedProductsFetched,
  isRelatedProductsRefetching,
  primaryCategoryId,
  recoBrandProducts,
  recommendations,
  relatedProducts
}) {
  const {tabs, tabsToShow} = useRelatedProductsTabs({
    brand,
    isApparel,
    isRecoBrandProductsFetched,
    isRecommendationsProductsFetched,
    isRelatedProductsFetched,
    primaryCategoryId,
    recoBrandProducts,
    recommendations,
    relatedProducts
  });

  const {
    hasAnyData,
    relatedProductsActiveTab,
    setRelatedProductsActiveTab,
    shouldTabbedViewRender,
    tabbedViewIsLoading
  } = useRelatedProductsState({
    breakpoint,
    isRecoBrandProductsFetched,
    isRecoBrandProductsRefetching,
    isRecommendationsProductsFetched,
    isRecommendationsProductsRefetching,
    isRelatedProductsFetched,
    isRelatedProductsRefetching,
    tabs
  });

  const {tabbedViewProducts} = useRelatedProductsData({
    alternativeProducts,
    brand,
    primaryCategoryId,
    recoBrandProducts,
    recommendations,
    relatedProducts,
    relatedProductsActiveTab,
    shouldTabbedViewRender
  });

  useRelatedProductsAnalytics({
    isRecoBrandProductsFetched,
    isRecommendationsProductsFetched,
    isRelatedProductsFetched,
    tabsToShow
  });

  return {
    hasAnyData,
    relatedProductsActiveTab,
    setRelatedProductsActiveTab,
    shouldTabbedViewRender,
    tabbedViewIsLoading,
    tabbedViewProducts,
    tabs
  };
}
